import React from 'react';
    import { motion } from 'framer-motion';
    import { Link } from 'react-router-dom';
    import * as FiIcons from 'react-icons/fi';
    import SafeIcon from '../common/SafeIcon';

    const { FiArrowRight, FiStar, FiZap, FiCalendar } = FiIcons;

    const HeroSection = ({ scrollY }) => {
      const handleLinkClick = () => {
        window.scrollTo(0, 0);
      };

      const handleBookingClick = () => {
        window.open('https://connect.withjahx.com', '_blank');
      };

      return (
        <section className="min-h-screen flex items-center justify-center relative pt-20">
          <div className="container mx-auto px-6 text-center relative z-10">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="max-w-4xl mx-auto"
            >
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2, duration: 0.5 }}
                className="mb-6"
              >
                <div className="inline-flex items-center space-x-2 bg-purple-900/30 px-4 py-2 rounded-full border border-purple-500/30">
                  <SafeIcon icon={FiStar} className="text-yellow-400" />
                  <span className="text-sm font-poppins text-purple-200">
                    Powered by Lumadious
                  </span>
                </div>
              </motion.div>
              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.8 }}
                className="text-5xl md:text-7xl font-orbitron font-bold mb-6 leading-tight"
              >
                Helping you build a{' '}
                <span className="clarity-gradient">consistent brand</span> and reclaim your time with{' '}
                <span className="clarity-gradient">clarity</span>,systems,and{' '}
                <span className="clarity-gradient">AI-powered automation</span>
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
                className="text-xl md:text-2xl text-gray-300 mb-8 font-poppins font-light max-w-3xl mx-auto leading-relaxed"
              >
                You're not lazy. You're overwhelmed. Let's build your business foundation together—one that actually
                works for you.
              </motion.p>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.7, duration: 0.8 }}
                className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4"
              >
                <a href="https://discord.withjahx.com" target="_blank" rel="noopener noreferrer">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-gradient-to-r from-purple-600 to-blue-600 px-8 py-4 rounded-full font-poppins font-semibold text-lg glow-button flex items-center space-x-2"
                  >
                    <span>Join Clarity Club</span>
                    <SafeIcon icon={FiArrowRight} />
                  </motion.button>
                </a>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleBookingClick}
                  className="bg-gradient-to-r from-purple-500/80 to-blue-500/80 px-8 py-4 rounded-full font-poppins font-semibold text-lg text-white flex items-center space-x-2 shadow-lg"
                >
                  <SafeIcon icon={FiCalendar} />
                  <span>Book a Discovery Call</span>
                </motion.button>
                <Link to="/lumadious" onClick={handleLinkClick}>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="border-2 border-purple-500 text-purple-300 px-8 py-4 rounded-full font-poppins font-semibold text-lg hover:bg-purple-500/10 transition-colors flex items-center space-x-2"
                  >
                    <SafeIcon icon={FiZap} />
                    <span>Explore Automation</span>
                  </motion.button>
                </Link>
              </motion.div>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1, duration: 0.8 }}
                className="mt-12 text-gray-400 font-poppins"
              >
                <p className="mb-2">Trusted by thousands of creative entrepreneurs</p>
                <div className="flex justify-center items-center space-x-1">
                  {[...Array(5)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="text-yellow-400 fill-current" />
                  ))}
                  <span className="ml-2 text-gray-300">4.9/5 from our community</span>
                </div>
              </motion.div>
            </motion.div>
          </div>

          {/* Floating Elements */}
          <motion.div
            animate={{ y: [0, -20, 0], rotate: [0, 180, 360] }}
            transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
            className="absolute top-1/4 left-10 w-4 h-4 bg-purple-500 rounded-full opacity-60"
          />
          <motion.div
            animate={{ y: [0, -30, 0], rotate: [360, 180, 0] }}
            transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
            className="absolute top-1/3 right-10 w-6 h-6 bg-blue-500 rounded-full opacity-40"
          />
        </section>
      );
    };

    export default HeroSection;